import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';
import {
    DISMISSAL_STATUSES, MAX_LENGTH, MODAL_CUSTOM_MESSAGE, ORDER_NO_FORM_MILESTONE,
    ORDER_STATUS as OrderStatus, APPROVE_STATUS as ApproveStatus, ORDER_STATUS_COMPLETED,
    DATA_TYPE, REQUEST_TYPE_MILESTONE, REQUEST_TYPES, REQUEST_TYPE, ORDER_MILESTONE_LABEL,
    DASHBOARD_LABEL,
    WIRELINE_REQUEST_TYPES_ID,
    REQUEST_TYPES_ID,
    WIRELESS_REQUEST_TYPES_IDS,
    MILESTONE_FORM_VALIDATION,
    ORDER_STATUS, QUOTATION_CODE_DETAIL,
    CLIENTID
} from "../../../../../constants/external-constants";
import { InputFieldFloatingLabel as InputField, SelectFieldFloatingLabel as Select } from '../../../../common/custom-form/select-filter.component';
import CustomSearchableSelectWrapper from "../../../../common/custom-form/custom-searchable-select-wrapper.component";
import { TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import { TabberButton } from '../../../../common/custom-form/tabber-button.component';
import { Milestone } from '../../../../common/milestone/milestone.component';
import { ORDER_MILESTONE } from '../../../../../constants/external-constants';
import ApproverDetails from '../order-details/approver-details/approver-details.component';
import OrderLocationDetails from '../order-details/order-location-details/order-location-details.component';
import { Button } from 'react-bootstrap';
import "./order-form.component.css";
import { NoSubscription } from '../../../dashboard/no-subscription/no-subscription.component';
import { NotificationModal } from '../../../../common/modal/notification-modal.component';
import { ConfirmationModal } from "../../../../common/modal/modal.component";
import ModalContainer from '../../../../common/modal/modal-container/modal-container.component';
import OrderSubmittedMilestone from './modal-form/submitted-milestone.component';
import ReceiptConfirmedMilestone from './modal-form/receipt-confirmed.component';
import CircuitInstallMilestone from './modal-form/circuit-install.component';
import OrderMilestone from '../../../../common/sample-data/order-milestone';
import Translation from "../../../../common/translation/translation.component";
import { convertToFormatLocalDate, isObjectEqual } from "../../../../../utils/helpers.utils";
import { orderMilestoneAction } from '../../../../../store/external/order/milestone/order-milestone.reducer'
import { Loading } from '../../../../common/loading';
import { circuitOrderActions } from '../../../../../store/external/order/order-circuit.reducer';
import { inventoryCircuitEquipActions } from '../../../../../store/external/reports-reducer/inventory/details-view/add-equipment.reducer';
import { orderDetailsActions } from '../../../../../store/external/order/order-details.reducer';
import { inventoryCircuitSimActions } from '../../../../../store/external/inventory/details-view/add-sim.reducer';
import ContactInformationDetails from '../order-details/contact-information-details/contact-information-details';
import { stripeActions } from '../../../../../store/common/stripe/stripe.reducer';
import PaymentDetails from '../../../../common/stripe/payments-details';
import CustomSearchableDropdownWrapper from "../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";
class OrderDetailsForm extends Component {
    constructor(props) {
        super(props);
        this.ConfirmationModal = React.createRef();
        this.state = {
            activeIndex: 0,
            circuitId: 0,
            circuitStatusId: 0,
            circuitTypeId: 0,
            mrc: 0,
            primarySecondary: '',
            billingAccountId: 0,
            endUserId: 0,                       
            orderId: 0,
            imeiValue: null,
            vendorId: 0,
            serialNumber: null,
            equipmentType: '',
            hideModalFormBtn:false,
            selectedMilestoneIndex: -1,
            selectedMilestone: "",
            notifTitle: "Notification",
            notifMessage: "",
            showNotif: false,
            showModalForm:false,
            formModalTitle: "",
            isLoading: true,
            hoverSubTitle: '',
            rejectedCancel: false,            
            step: 0,
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            isCancel: false,
            orderMilestone: [],
            viewMileStoneIsDisableField: false,
            secondaryCircuitId: 0,
            secondayVendorId: 0,
            secondaryCircuitStatusId: 0,
            secondaryCircuitTypeId: 0,
            secondaryMrc: 0,
            secondaryPrimary: '',
            secondaryBillingAccountId: 0,
            secondaryEndUserId: 0,
            hasSecondaryCircuit : false,
            showPaymentInfo: false,
            isPaymentLoading: false,

        };
        this.TabberButtonExpediteRequest = React.createRef();
       this.milestoneRef=React.createRef();
    }

    async componentDidMount() {
        const { orderDetailsId, getOrderDetails, getCircuitOrder, requestTypeId, getCircuitOrderEquipList, getCircuitOrderSimList, circuitOrderForm } = this.props;
         if (requestTypeId != REQUEST_TYPES_ID.newQuotation){
            //get circuit id
            var circuitOrder = await getCircuitOrder(orderDetailsId, requestTypeId, true, false, "")
            var secondaryCircuitOrder = await getCircuitOrder(orderDetailsId, requestTypeId, false, true, "Secondary")

            if (secondaryCircuitOrder)
            {
                this.setState({
                    hasSecondaryCircuit: true
                });
            }
            //get serial number
            getCircuitOrderSimList(orderDetailsId, requestTypeId, circuitOrder.OrderCircuitDetailId).then(() =>{
                const { circuitSimList } = this.props.inventoryCircuitSIM;
                if (circuitSimList.datatable && circuitSimList?.datatable[0]?.dataItem?.length > 0) {
                    this.setState({
                        serialNumber: circuitSimList?.datatable[0]?.dataItem.every(item => item.SerialNumber)
                    });
                }
                else {
                    this.setState({
                        serialNumber: true
                    });
                }
            });

             if (circuitOrder.CircuitId || requestTypeId === REQUEST_TYPES_ID.newMobile || requestTypeId === REQUEST_TYPES_ID.simAndDevice
                 || requestTypeId === REQUEST_TYPES_ID.newMobileDevice || requestTypeId === REQUEST_TYPES_ID.wifiDongleAndDataCard
                 || requestTypeId === REQUEST_TYPES_ID.simAndDeviceBSA || requestTypeId === REQUEST_TYPES_ID.simOnlyBSA
                 || requestTypeId === REQUEST_TYPES_ID.multiSIMBSA || requestTypeId === REQUEST_TYPES_ID.wifiDongleAndDataCardBIN
                 || requestTypeId === REQUEST_TYPES_ID.voiceSIMBIN || requestTypeId === REQUEST_TYPES_ID.wifiDongleDataCardAndVoiceSIMBIN
                 || requestTypeId === REQUEST_TYPES_ID.portIn) {
                this.setState({
                    circuitId: circuitOrder.CircuitId,
                    vendorId: circuitOrder.VendorID,
                    circuitStatusId: circuitOrder.CircuitStatusID,
                    circuitTypeId: circuitOrder.CircuitTypeId,
                    mrc: circuitOrder.MRC,
                    primarySecondary: circuitOrder.PrimarySecondary,
                    billingAccountId: circuitOrder.FinanceAccountID,
                    endUserId: circuitOrder.EndUserID,
                },
                    async () => {
                        await getCircuitOrderEquipList(this.state.vendorId, orderDetailsId, requestTypeId, circuitOrderForm.circuitOrderDetails.circuitTypeID).then(() => {
                            const { circuitEquipList } = this.props.inventoryCircuitEquip;
                            if (circuitEquipList?.datatable && circuitEquipList?.datatable[0]?.dataItem?.length > 0) {
                                this.setState({
                                    imeiValue: circuitEquipList.datatable[0].dataItem.every(
                                        (item) => item.IMEISerialNumber
                                    ),
                                    equipmentType: circuitEquipList?.datatable[0]?.dataItem[0].Type,
                                })
                            } else {
                                this.setState({
                                    imeiValue: true,
                                    equipmentType: true,
                                })
                            }
                        });
                    });
            }
            else if (requestTypeId === REQUEST_TYPES_ID.newSubscriptionWireline)
            {
                this.setState({
                    circuitId: circuitOrder.CircuitId,
                    vendorId: circuitOrder.VendorID,
                    circuitStatusId: circuitOrder.CircuitStatusID,
                    circuitTypeId: circuitOrder.CircuitTypeId,
                    mrc: circuitOrder.MRC,
                    primarySecondary: circuitOrder.PrimarySecondary,
                    billingAccountId: circuitOrder.FinanceAccountID,
                    endUserId: circuitOrder.EndUserID
                },
                    async () => {
                        await getCircuitOrderEquipList(this.state.vendorId, orderDetailsId, requestTypeId, circuitOrderForm.circuitOrderDetails.circuitTypeID).then(() => {
                            const { circuitEquipList } = this.props.inventoryCircuitEquip;
                            if (circuitEquipList?.datatable && circuitEquipList?.datatable[0]?.dataItem?.length > 0) {
                                this.setState({
                                    imeiValue: circuitEquipList.datatable[0].dataItem.every(
                                        (item) => item.IMEISerialNumber
                                    ),
                                    equipmentType: circuitEquipList?.datatable[0]?.dataItem[0].Type,
                                })
                            } else {
                                this.setState({
                                    imeiValue: true,
                                    equipmentType: true,
                                })
                            }
                        });
                    });

                if (this.state.hasSecondaryCircuit) {
                    this.setState({
                        secondaryCircuitId: secondaryCircuitOrder.CircuitId,
                        secondaryVendorId: secondaryCircuitOrder.VendorID,
                        secondaryCircuitStatusId: secondaryCircuitOrder.CircuitStatusID,
                        secondaryCircuitTypeId: secondaryCircuitOrder?.CircuitTypeId,
                        secondaryMrc: secondaryCircuitOrder.MRC,
                        secondaryPrimary: secondaryCircuitOrder.PrimarySecondary,
                        secondaryBillingAccountId: secondaryCircuitOrder.FinanceAccountID,
                        secondaryEndUserId: secondaryCircuitOrder.EndUserID,
                    })
                }
            }         
        }
      this.fetchOrderMilestoneDetails()
      document.addEventListener('click', this.handleClickOutsideMilstone);     
    }

    fetchOrderMilestoneDetails = async () => {
        var orderDetail = await this.executeOrderDetails();
        this.toggleButton(orderDetail);
        this.loadMilestoneDetails();
    }

    fetchMilestoneDetails = () => {
        const { getOrderMilestone, orderDetailsId, quotationRequestId, requestTypeId } = this.props;
        let orderRequestId = requestTypeId === REQUEST_TYPES_ID.newQuotation ? quotationRequestId : orderDetailsId;
        return getOrderMilestone(orderRequestId, requestTypeId)
        
    }


    fetchQuotation = async () => {
        const { quotationRequestId, requestTypeId, getNewQuotationDetails, getVendorList } = this.props;
        var qoutationDetails = await getNewQuotationDetails(quotationRequestId);
        var vendordetails = await getVendorList(quotationRequestId)
        this.loadMilestoneDetails();
        return (vendordetails, qoutationDetails)
    }
    loadMilestoneDetails = async () =>{
        try {
            await this.fetchMilestoneDetails();
            const { milestoneDetails } = this.props.orderMilestoneDetails;
            const { orderDetailsForm } = this.props
            const combinedMilestones = this.handleMilestoneData(ORDER_MILESTONE, milestoneDetails);

            this.setState({
                rejectedCancel: combinedMilestones.some(
                    milestone => milestone.status === "rejected" || milestone.status === "cancelled"
                )
            })

            if (orderDetailsForm.requestType === REQUEST_TYPES.changeVendor
                || orderDetailsForm.requestType === REQUEST_TYPES.accessory
                || orderDetailsForm.requestType === REQUEST_TYPES.intlRoamAccess 
                || orderDetailsForm.requestType === REQUEST_TYPES.other
                || orderDetailsForm.requestType === REQUEST_TYPES.changeUser
                || orderDetailsForm.requestType === REQUEST_TYPES.changeNumber
                || orderDetailsForm.requestType === REQUEST_TYPES.enableHotspot
                || orderDetailsForm.requestType === REQUEST_TYPES.simActivation
                || orderDetailsForm.requestType === REQUEST_TYPES.suspendResumeService
                || orderDetailsForm.requestType === REQUEST_TYPES.pukCode
                || orderDetailsForm.requestType === REQUEST_TYPES.otherSIMReplacement
                || orderDetailsForm.requestType === REQUEST_TYPES.otherChangeOfPlan
                || orderDetailsForm.requestType === REQUEST_TYPES.callingAccess
                || orderDetailsForm.requestType === REQUEST_TYPES.roamingAccess
                || orderDetailsForm.requestType === REQUEST_TYPES.replaceOrUpgradeDevice
                || orderDetailsForm.requestType === REQUEST_TYPES.updatePlan
                ) 
                {
                combinedMilestones.forEach(milestone => {
                    if (milestone.key === 'CircuitInstalledModel') {
                        milestone.label = 'circuit_changed';
                    }
                });
            } else if (orderDetailsForm.requestType === REQUEST_TYPES.terminateSubscription
                || orderDetailsForm.requestType === REQUEST_TYPES.portOut || orderDetailsForm.requestType === REQUEST_TYPES.terminateSubscriptionWireline)
            {
                combinedMilestones.forEach(milestone => {
                    if (milestone.key === 'CircuitInstalledModel') {
                        milestone.label = 'circuit_disconnected';
                    }
                });
            }
            else if (orderDetailsForm.requestType === REQUEST_TYPES.newQuotation)
            {
                combinedMilestones.forEach(milestone => {
                    if (milestone.key === 'OrderCompletedModel') {
                        milestone.label = 'order_completed';
                    }
                });
            }

            const completedCount = combinedMilestones.reduce((count, milestone) => count + (milestone.status === "completed" ? 1 : 0), 0);
            this.setState({ orderMilestone: combinedMilestones, activeIndex: completedCount - 1}); // need to double check
            this.setState({isLoading:false});
        } catch (error) {
            console.error('order milestone have an error: ', error);
            this.setState({isLoading:false});
        }
    }

    componentWillUnmount() {
       document.addEventListener('click', this.handleClickOutsideMilstone);
    }
   
    handleMilestoneData = (milestoneData, apiData) => {
        let combined = milestoneData.reduce((acc, milestone) => {
            if (apiData[milestone.key]) {   
                const isDismissalStatus = DISMISSAL_STATUSES.some(status => status.key === milestone.key);

                let status = "";
                const dismissalStatus = DISMISSAL_STATUSES.find(status => status.key === milestone.key);

                if (ORDER_STATUS_COMPLETED.includes(apiData[milestone.key].Status)) {
                    status = "completed";
                } else if (dismissalStatus && apiData[milestone.key].Status === dismissalStatus.id) {
                    status = dismissalStatus.label;
                }

                if (isDismissalStatus && apiData[milestone.key].Status === "") {
                    return acc
                }
                acc.push({
                    key: milestone.key,
                    label: milestone.label,
                    status: status,
                    date: apiData[milestone.key].Date
                }); 
            }
            return acc;
        }, []);
    
        let lastCompletedIndex = -1;
        combined.forEach((milestone, index) => {
            if (milestone.status === "completed") {
                lastCompletedIndex = index;
            }
        });
    
        const specialStatusIndex = combined.findIndex(m => DISMISSAL_STATUSES.some(status => status.key === m.key && m.status === status.label));     
        if (specialStatusIndex !== -1 && lastCompletedIndex !== -1 && specialStatusIndex > lastCompletedIndex) {
            const specialStatus = combined.splice(specialStatusIndex, 1)[0];
            combined.splice(lastCompletedIndex + 1, 0, specialStatus);
        }
    
        return combined;
    };
    
    handleOpenRequestDetails = (id, type) =>{
        const { OpenRequestDetails, orderDetailsForm } = this.props;
        OpenRequestDetails(id, type, orderDetailsForm.orderStatusId)        
    }
    toggleButton = (orderDetail) => {
        if (orderDetail) {
            if (this.TabberButtonExpediteRequest.current) {
                this.TabberButtonExpediteRequest.current.toggle(orderDetail.ExpediteRequest ?? '');
            }
        }
    }
    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }
    getSelectedMilestone = (index) =>{
        const {orderMilestone} = this.state;
        const milestone = orderMilestone[index];
        var milestoneLabel = milestone.label;
        if (milestoneLabel === "circuit_changed")
        {
            milestoneLabel = ORDER_MILESTONE.find(x => x.step === index).label
        }
        const orderDetailsMilestone = ORDER_MILESTONE.find(m => m.label === milestoneLabel)
        if(orderDetailsMilestone)
        {
            this.setState({step:orderDetailsMilestone.step})
        }  
        else {
            this.setState({step:0})
        }    
        return milestone ? milestone.label : '';
    }

    handleHideSelectionMilestone=()=>{
        this.setState({showSelection:-1});
    }

    handleClickOutsideMilstone = (e) => {
        if (e.target.classList[0] === "custom-select-input") {
            return;
        }

        if (this.milestoneRef.current && !this.milestoneRef.current.contains(e.target))
        {
            this.handleHideSelectionMilestone();
        }
    }

    requiredFieldByRequestType = (requestType) => {
        const { circuitId, circuitStatusId, circuitTypeId, mrc, primarySecondary, billingAccountId, endUserId, imeiValue, serialNumber, equipmentType, hasSecondaryCircuit, secondaryCircuitTypeId, secondaryPrimary, secondaryBillingAccountId, secondaryEndUserId } = this.state;
        const { circuitSimList } = this.props.inventoryCircuitSIM;
        const { requestTypeId } = this.props;

        const hasSimData = (circuitSimList?.datatable?.[0]?.dataItem?.length || 0) > 0;

        const restrictedRequestTypes = [
            REQUEST_TYPES_ID.changeNumber,
            REQUEST_TYPES_ID.enableHotspot,      
            REQUEST_TYPES_ID.simActivation,
            REQUEST_TYPES_ID.other,       
            REQUEST_TYPES_ID.suspendResumeService,
            REQUEST_TYPES_ID.pukCode,
            REQUEST_TYPES_ID.otherSIMReplacement,
            REQUEST_TYPES_ID.otherChangeOfPlan,
        ];

        switch (requestType) {
            case REQUEST_TYPES.simAndDevice:
            case REQUEST_TYPES.newMobileDevice:
            case REQUEST_TYPES.wifiDongleAndDataCard:
            case REQUEST_TYPES.simAndDeviceBSA:
            case REQUEST_TYPES.simOnlyBSA:
            case REQUEST_TYPES.multiSIMBSA:
            case REQUEST_TYPES.wifiDongleAndDataCardBIN:
            case REQUEST_TYPES.voiceSIMBIN:
            case REQUEST_TYPES.wifiDongleDataCardAndVoiceSIMBIN:
            case REQUEST_TYPES.newMobileSubscription:
                return circuitTypeId && (typeof mrc === 'number' && !isNaN(mrc)) && primarySecondary && billingAccountId && endUserId && serialNumber && imeiValue;
            case REQUEST_TYPES.portIn:
                return circuitTypeId && (typeof mrc === 'number' && !isNaN(mrc)) && primarySecondary && billingAccountId && endUserId && serialNumber && imeiValue;
            case REQUEST_TYPES.newCircuit:
                if (hasSecondaryCircuit === true) {
                    return circuitTypeId && (typeof mrc === 'number' && !isNaN(mrc)) && primarySecondary && billingAccountId && endUserId && serialNumber && imeiValue && secondaryCircuitTypeId && secondaryPrimary && secondaryBillingAccountId && secondaryEndUserId;
                } else
                {
                    return circuitTypeId && (typeof mrc === 'number' && !isNaN(mrc)) && primarySecondary && billingAccountId && endUserId && serialNumber && imeiValue;
                }
            case REQUEST_TYPES.terminateSubscription:
            case REQUEST_TYPES.portOut:
                return circuitId;
    
            case REQUEST_TYPES.replaceOrUpgradeDevice:
                return circuitTypeId && (typeof mrc === 'number' && !isNaN(mrc)) && primarySecondary && billingAccountId && endUserId && imeiValue;
            case REQUEST_TYPES.changeVendor :
                return billingAccountId && imeiValue;
            case REQUEST_TYPES.changeUser:            
            case REQUEST_TYPES.accessory:
                return billingAccountId;
    
            case REQUEST_TYPES.changeNumber:
            case REQUEST_TYPES.enableHotspot:
            case REQUEST_TYPES.simActivation:
            case REQUEST_TYPES.suspendResumeService:
            case REQUEST_TYPES.other:

                if(requestTypeId == REQUEST_TYPES_ID.other && (circuitId == null || circuitId == 0) ) return true

                if(restrictedRequestTypes.includes(requestTypeId) && !hasSimData){
                    return false;
                }

                return (circuitId !== null && circuitId !== 0) ? (equipmentType === 'Device'
                    ? circuitId && circuitStatusId && circuitTypeId && (typeof mrc === 'number' && !isNaN(mrc)) && primarySecondary && billingAccountId && endUserId && imeiValue
                    : circuitId && circuitStatusId && circuitTypeId && (typeof mrc === 'number' && !isNaN(mrc)) && primarySecondary && billingAccountId && endUserId) : false;
            case REQUEST_TYPES.wirelineChangeVendor:
                return equipmentType === 'Device'
                ? circuitId && circuitStatusId && circuitTypeId && (typeof mrc === 'number' && !isNaN(mrc)) && primarySecondary && billingAccountId && endUserId && imeiValue
                    : circuitId && circuitStatusId && circuitTypeId && (typeof mrc === 'number' && !isNaN(mrc)) && primarySecondary && billingAccountId && endUserId;
            
            default:
                return true;
        }
    }
    

    onClickMilestone = async(index) =>{
        const {activeIndex, circuitId, imeiValue, selectedMilestone, rejectedCancel}=this.state;
        const { orderDetailsForm, orderDetailsId, requestTypeId, checkCircuitDuplicate } = this.props; 
        const selectedMilestoneLabel = await this.getSelectedMilestone(index);   
        let orderId = requestTypeId === REQUEST_TYPES_ID.newQuotation ? 0 : orderDetailsId 
        const circuitHasDuplicate = await checkCircuitDuplicate(requestTypeId, orderId);
        this.setState({selectedMilestone:selectedMilestoneLabel, selectedMilestoneIndex:index},()=>{

            if (index === 3)
            {
                if (!this.requiredFieldByRequestType(orderDetailsForm.requestType))
                {
                    if (activeIndex === 2 && parseInt(orderDetailsForm.orderStatusId) !== OrderStatus.canceled
                        && parseInt(orderDetailsForm.orderStatusId) !== OrderStatus.rejected)
                    {
                        this.setState({ showNotif: true })
                        this.setState({ notifMessage: MODAL_CUSTOM_MESSAGE.order_completing_request })
                    } else if (activeIndex >= 0)
                    {
                        if (parseInt(orderDetailsForm.approvalStatusId) === ApproveStatus.pending || parseInt(orderDetailsForm.orderStatusId) === OrderStatus.rejected
                            || parseInt(orderDetailsForm.orderStatusId) === OrderStatus.canceled) {
                            this.setState({showNotif:true})
                            this.setState({notifMessage:MODAL_CUSTOM_MESSAGE.order_cancel_approve})
                        }
                    }
                }
                else {
                    if (circuitHasDuplicate && parseInt(orderDetailsForm.orderStatusId) !== OrderStatus.completed) {
                        this.setState({ showNotif: true })
                        this.setState({ notifMessage: MODAL_CUSTOM_MESSAGE.circuit_already_exist })
                    }
                    else
                    { 
                        if (this.state.showSelection === index || ORDER_NO_FORM_MILESTONE.includes(selectedMilestoneLabel)
                            || selectedMilestoneLabel === ORDER_MILESTONE_LABEL.cancelled || selectedMilestoneLabel === ORDER_MILESTONE_LABEL.rejected)
                        {
                            this.handleHideSelectionMilestone();
                        }
                        else
                        {
                            if (activeIndex >= index)
                            {
                                this.setState({ showSelection: index, hideModalFormBtn: true });

                            }
                            else
                            {
                                this.handleShowForm(index);
                                this.setState({ hideModalFormBtn: false });
                            }
                        }
                    }
                }
            }
            else
            {
                if (this.state.showSelection === index || ORDER_NO_FORM_MILESTONE.includes(selectedMilestoneLabel)
                    || selectedMilestoneLabel === ORDER_MILESTONE_LABEL.cancelled || selectedMilestoneLabel === ORDER_MILESTONE_LABEL.rejected)
                {
                    this.handleHideSelectionMilestone();
                }
                else
                {
                    if (activeIndex >= index)
                    {               
                        this.setState({showSelection:index,hideModalFormBtn:true});
                        if(activeIndex===index && index !== 3) {
                            if(rejectedCancel) {
                                this.setState({hoverSubTitle:null})
                            } else {
                                this.setState({hoverSubTitle:'Rollback Milestone'})
                            }                            
                        } else {
                            this.setState({hoverSubTitle:null})
                        }
                        
                    } else {
                         this.handleShowForm(index);     
                          this.setState({hideModalFormBtn:false});           
                    }            
                }
            }
        })
    }

    handleShowForm = (index) => {
        const { selectedMilestone, activeIndex, selectedMilestoneIndex } = this.state; 
        const { orderDetailsForm, orderMilestoneForm, orderDetails, requestTypeId } = this.props;
        this.setState({ viewMileStoneIsDisableField: true })
        const isPendingOrRejectedOrCanceled =
            parseInt(orderDetails.orderData.ApprovalStatusId) === ApproveStatus.pending ||
            parseInt(orderDetails.orderData.OrderStatusId) === OrderStatus.rejected ||
            parseInt(orderDetails.orderData.OrderStatusId) === OrderStatus.canceled;
        if(index!==-1) {
            
            if (selectedMilestone === ORDER_MILESTONE_LABEL.submitted)
            {
                this.setState({formModalTitle: "order_submitted_milestone"})
            }
            else if (selectedMilestone === ORDER_MILESTONE_LABEL.receipt_confirmed)
            {
                this.setState({formModalTitle: "order_receipt_confirmed_milestone"})
            }
            else if (selectedMilestone === ORDER_MILESTONE_LABEL.installed
                     || selectedMilestone === ORDER_MILESTONE_LABEL.changed
                     || selectedMilestone === ORDER_MILESTONE_LABEL.disconnected
                     || selectedMilestone === ORDER_MILESTONE_LABEL.completed)
            {
                    if (orderMilestoneForm.orderType === REQUEST_TYPE_MILESTONE.simple && requestTypeId === REQUEST_TYPES_ID.newQuotation)
                    {
                        this.setState({formModalTitle: "order_completed_milestone"})
                    }
                    else if(orderMilestoneForm.orderType === REQUEST_TYPE_MILESTONE.simple)
                    {
                         this.setState({formModalTitle: "circuit_installed_milestone"})
                    }
                    else if (orderMilestoneForm.orderType === REQUEST_TYPE_MILESTONE.change)
                    {
                        this.setState({formModalTitle: "circuit_change_milestone"})
                    }
                    else
                    {
                        this.setState({formModalTitle: "circuit_disconnect_milestone"})
                    }
            }      
            if (isPendingOrRejectedOrCanceled && [1, 2, 3, 4].includes(index)) {
                this.setState({ showNotif: true })
                this.setState({ notifMessage: MODAL_CUSTOM_MESSAGE.order_cancel_approve })
            }
            else if (parseInt(orderDetails.orderData.ApprovalStatusId) === ApproveStatus.approved
                || parseInt(orderDetails.orderData.ApprovalStatusId) === ApproveStatus.rejected)
            {
                if (activeIndex === 0 && selectedMilestone === ORDER_MILESTONE_LABEL.submitted && 
                    parseInt(orderDetails.orderData.ApprovalStatusId) !== ApproveStatus.rejected &&
                    parseInt(orderDetails.orderData.OrderStatusId) !== OrderStatus.canceled &&
                    parseInt(orderDetails.orderData.OrderStatusId) !== OrderStatus.rejected)
                {
                    this.setState({showModalForm:true})
                }
                else if (activeIndex === 1 && selectedMilestone === ORDER_MILESTONE_LABEL.receipt_confirmed
                    && parseInt(orderDetails.orderData.OrderStatusId) !== OrderStatus.canceled
                    && parseInt(orderDetails.orderData.OrderStatusId) !== OrderStatus.rejected) 
                {
                    this.setState({showModalForm:true})
                }
                else if (activeIndex === 2
                    && parseInt(orderDetails.orderData.ApprovalStatusId) === ApproveStatus.approved 
                    && parseInt(orderDetails.orderData.OrderStatusId) !== OrderStatus.canceled
                    && parseInt(orderDetails.orderData.OrderStatusId) !== OrderStatus.rejected
                    && (selectedMilestone === ORDER_MILESTONE_LABEL.installed
                    || selectedMilestone === ORDER_MILESTONE_LABEL.changed
                    || selectedMilestone === ORDER_MILESTONE_LABEL.completed
                    || selectedMilestone === ORDER_MILESTONE_LABEL.disconnected)) 
                {
                    this.setState({showModalForm:true})
                }
                else if (index === -1)
                {
                    this.setState({showModalForm:true})
                }
                else if ((orderDetailsForm.approvalStatus === DASHBOARD_LABEL.approved
                    || orderDetailsForm.approvalStatus === DASHBOARD_LABEL.rejected
                    || orderDetailsForm.approvalStatus === DASHBOARD_LABEL.cancelled
                ) && (activeIndex >= selectedMilestoneIndex))
                {
                    this.setState({showModalForm:true})
                }  
            }
            else if(requestTypeId === REQUEST_TYPES_ID.newQuotation) {
                if (activeIndex === 0 && selectedMilestone === ORDER_MILESTONE_LABEL.submitted && 
                    parseInt(orderDetails.orderData.RequestStatusId) !== OrderStatus.canceled &&
                    parseInt(orderDetails.orderData.RequestStatusId) !== OrderStatus.rejected)
                {
                    this.setState({showModalForm:true})
                }
                else if (activeIndex === 1 && selectedMilestone === ORDER_MILESTONE_LABEL.receipt_confirmed
                    && parseInt(orderDetails.orderData.RequestStatusId) !== OrderStatus.canceled
                    && parseInt(orderDetails.orderData.RequestStatusId) !== OrderStatus.rejected) 
                {
                    this.setState({showModalForm:true})
                }
                else if (activeIndex === 2
                    && parseInt(orderDetails.orderData.RequestStatusId) !== OrderStatus.canceled
                    && parseInt(orderDetails.orderData.RequestStatusId) !== OrderStatus.rejected
                    && (selectedMilestone === ORDER_MILESTONE_LABEL.installed
                    || selectedMilestone === ORDER_MILESTONE_LABEL.changed
                    || selectedMilestone === ORDER_MILESTONE_LABEL.completed
                    || selectedMilestone === ORDER_MILESTONE_LABEL.disconnected)) 
                {
                    this.setState({showModalForm:true})
                }
                else if (index === -1)
                {
                    this.setState({showModalForm:true})
                }
                else if ((orderDetailsForm.approvalStatusId === ORDER_STATUS.progress
                    || orderDetailsForm.approvalStatusId === ORDER_STATUS.completed
                    || orderDetailsForm.approvalStatusId === ORDER_STATUS.cancelled
                ) && (activeIndex >= selectedMilestoneIndex))
                {
                    this.setState({showModalForm:true})
                }  
            }
        }
        this.handleHideSelectionMilestone();
    }

    closeNotif = () => {
        this.setState({showNotif:false})
    }
    closeFormModal = () => {
        this.setState({showModalForm:false})
    }
    onClickSaveModal = async() => {
        const { step, selectedMilestoneIndex } = this.state; 
        const { savedOrderMilestone, orderDetailsId, circuitOrderForm, quotationRequestId, requestTypeId  } = this.props;
        //const milestoneStep = step===0 ? selectedMilestoneIndex + 1 : step; 
        const milestoneStep = selectedMilestoneIndex + 1;
        let orderRequestId = requestTypeId === REQUEST_TYPES_ID.newQuotation ? quotationRequestId : orderDetailsId;
        await savedOrderMilestone(orderRequestId, requestTypeId, milestoneStep, circuitOrderForm.circuitOrderDetails?.statusID).then(()=>{
            this.fetchMilestoneDetails()
        })
        this.toggleSaveNotif(true, 'Success', 'Changes have been saved');
        this.closeFormModal() 
    }
    //Get Milestone Form Modal
    renderMilestoneComponent() {
        const { selectedMilestone, viewMileStoneIsDisableField, hideModalFormBtn } = this.state;
        const {orderDetailsForm, requestTypeId} = this.props;
        switch (selectedMilestone) {
            case "order_submitted":              
                return requestTypeId !== REQUEST_TYPES_ID.newQuotation 
                    ? <OrderSubmittedMilestone requestType={orderDetailsForm.requestType} disableFields={hideModalFormBtn} /> 
                    : <OrderSubmittedMilestone requestType={orderDetailsForm.requestType} customClass={'order-quotation-milestone'} disableFields={hideModalFormBtn}/>;
            case "order_receipt_confirmed":               
                return requestTypeId !== REQUEST_TYPES_ID.newQuotation 
                    ? <ReceiptConfirmedMilestone requestType={orderDetailsForm.requestType} disableFields={hideModalFormBtn} />
                    : <ReceiptConfirmedMilestone requestType={orderDetailsForm.requestType} customClass={'order-quotation-milestone'} disableFields={hideModalFormBtn}/>;
            case "order_completed":              
                return <CircuitInstallMilestone requestType={orderDetailsForm.requestType}  customClass={'order-quotation-milestone'} disableFields={hideModalFormBtn}/>;
            case "circuit_installed":
            case "circuit_changed":    
            case "circuit_disconnected":                
                return <CircuitInstallMilestone requestType={orderDetailsForm.requestType} disableFields={hideModalFormBtn} />;
            default:
                return null;
        }
    }
    canCancelOrder() {
        const { $form  } = this.props;
        let orderStatusId = parseInt($form.loadedValue.orderStatusId);
        let approveStatusId = parseInt($form.loadedValue.approveStatusId);
        var canCancel = true;
        if (orderStatusId === OrderStatus.completed || orderStatusId === OrderStatus.canceled || orderStatusId === OrderStatus.rejected || approveStatusId === ApproveStatus.rejected) {
            canCancel = false;
        }
        return canCancel;
    }
    disableSaveChanges = () => {
        const { orderDetailsForm, $form } = this.props;
        let initialFormValue = { ...$form.loadedValue };
        let updatedFormValue = { ...orderDetailsForm };
        const unchangedOrderDetails = isObjectEqual(initialFormValue, updatedFormValue);
        let disabled = !orderDetailsForm.assignedTEMAnalystId || !orderDetailsForm.orderStatusId || !orderDetailsForm.approvalStatusId;
      
        if (disabled) {
            return disabled;
        }
        if(unchangedOrderDetails) {
            return unchangedOrderDetails
        }
        return false;
        
    }

    isOrderStatusCompleted = () => {
        const { orderDetailsForm } = this.props;
        return orderDetailsForm?.orderStatus === "Completed" || orderDetailsForm?.orderStatusId === ORDER_STATUS.completed;
    }
   
    handleNotification = e => {
        const { saveNotif } = this.state;
        this.setState({ saveNotif: { ...saveNotif, show: false } });
        if (this.orderCanBeCompleted()) {
            this.fetchOrderMilestoneDetails();
        }
        
    }

    orderCanBeCompleted(orderStatusId) {
        const { $form, orderDetailsForm } = this.props;
        orderStatusId = orderStatusId === null || orderStatusId === undefined ? parseInt(orderDetailsForm.orderStatusId) : orderStatusId;
        if(orderStatusId === OrderStatus.completed) {
            return ($form.loadedValue.orderCompletionDate !== null && $form.loadedValue.orderCompletionDate !== undefined && $form.loadedValue.orderCompletionDate !== "") ? true : false;
        }
        return true;
    }

    executeOrderDetails = async () => {
        const {  requestTypeId, orderDetailsId,getNewQuotationDetails, getOrderDetails, getVendorList, quotationRequestId } = this.props;
        if(requestTypeId === REQUEST_TYPES_ID.newQuotation) {
            await getNewQuotationDetails(quotationRequestId);
            await getVendorList(quotationRequestId)
        }
        else{
            await getOrderDetails(orderDetailsId)
        }
    }

    handleOrderConfirmation = async () => {
        const { isCancel } = this.state;
        const { saveOrderForm, orderDetailsForm, setCancelOrderStatus, requestTypeId } = this.props;
        this.ConfirmationModal.current.handleClose();
        let orderStatusId = parseInt(orderDetailsForm.orderStatusId);
        if(isCancel) {
            setCancelOrderStatus();
        }
        if (!this.orderCanBeCompleted(orderStatusId)) {
            return this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title"), 'Progress the order milestones to complete the request.');
        }
        
        let orderRequestId = requestTypeId === REQUEST_TYPES_ID.newQuotation ? orderDetailsForm.quotationRequestId : orderDetailsForm.orderId
        let result = await saveOrderForm(orderRequestId, requestTypeId);
        if(result.success) {
            this.toggleSaveNotif(true, isCancel ? 'Cancel Order' : 'Update Order', result.message);
        }
        else{
            this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title"),  result.message);
        } 
        
    }

    toggleSaveModal = (isShow, title, message, confirmAction = () => { }) => {
        const { saveModal } = this.state;

        if (isShow) {
            this.ConfirmationModal.current.handleShow();
        }
        else {
            this.ConfirmationModal.current.handleClose();
        }
        this.setState({
            saveModal: {
                ...saveModal,
                title: title ?? "",
                messageBody: message ?? "",
                confirmAction: confirmAction
            }
        });
    }
    toggleSaveNotif = (isShow, title, message) => {
        const { saveNotif } = this.state;
        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? ""
            }
        });
    }

    handleButtonConfirmation = async (buttonSave = true) => {
        let confirmMessage = "Are you sure you want to update this order?";
        let modalTitle = this.toLocaleLanguage("update");
        this.setState({ isCancel: false});
        if(!buttonSave) {
            this.setState({ isCancel: true});
            confirmMessage = this.toLocaleLanguage("modal_cancel_content");
            modalTitle = this.toLocaleLanguage("modal_cancel_title");
        }
        var confirmAction = () => this.handleOrderConfirmation();
        this.toggleSaveModal(true, modalTitle, confirmMessage, confirmAction); 
    }

    formatHoverData = () => {

        // replace on the actual data on api
        const hide=false;
        const hoverData = {
            hoverTitle: "View Milestone",
            hoverDescription: "Details",
            hoverSubTitle: hide ? "Rollback Milestone" : ''
        };
        return Object.values(hoverData).join('\n');
    }

    selectedMilestoneData =()=>{
        const { hoverSubTitle } =this.state;
        return (
            <div className='milestone-selector__container'>
                <p onClick={this.handleShowForm}>View Milestone Details</p>
                {
                    hoverSubTitle &&
                    <p className='mt-3'>{hoverSubTitle}</p>
                }               
            </div>
        )
    }

     handleCloseFormModal = ()=>{
        this.setState({showPaymentInfo:false})
    }

    handleFetchStripeInfo= async (orderId) => {
        const { fetchPaymentInfo, fetchVirtualCardInfo } = this.props;
        this.setState({
            isPaymentLoading:true,
            showPaymentInfo: true
        })
        const data = await fetchPaymentInfo(orderId);
        if(data[0]) {
            this.setState({
            isPaymentLoading: false
        })
        }
       
    }

    disabledModalBtn = () => {
        const { selectedMilestone } = this.state;
        const { orderMilestoneForm } = this.props;
        const {requestType} = this.props.orderDetailsForm;

        const isFormValidate = (validate) => Object.values(validate).includes(requestType)

        const conditions = {
            order_submitted: () => isFormValidate(MILESTONE_FORM_VALIDATION)
                ? orderMilestoneForm.orderSubmitDate 
                : orderMilestoneForm.orderSubmitDate
                && orderMilestoneForm.circuitRequestedDate,
            order_receipt_confirmed: () => isFormValidate(MILESTONE_FORM_VALIDATION)
                ?  (requestType === REQUEST_TYPES.newQuotation
                    || requestType === QUOTATION_CODE_DETAIL.newQuotation
                    || requestType === QUOTATION_CODE_DETAIL.upgradeQuotation)
                ? orderMilestoneForm.carrierConfirmationDate 
                : orderMilestoneForm.carrierConfirmationDate
                && orderMilestoneForm.carrierTrackingID
                && orderMilestoneForm.telcoRepresentativeAssigned
                : orderMilestoneForm.carrierConfirmationDate
                && orderMilestoneForm.carrierTrackingID
                && orderMilestoneForm.telcoRepresentativeAssigned
                && orderMilestoneForm.vendorCommitmentDeliveryDate,
            circuit_installed: () => orderMilestoneForm.installOrdisconnectDate && orderMilestoneForm.orderClosedDate,
            circuit_disconnected: () => orderMilestoneForm.installOrdisconnectDate && orderMilestoneForm.orderClosedDate,
            circuit_changed: () => orderMilestoneForm.installOrdisconnectDate && orderMilestoneForm.orderClosedDate,
            order_completed: () => orderMilestoneForm.orderClosedDate
        };

        return conditions[selectedMilestone] ? !conditions[selectedMilestone]() : true;
    }

    handleTEMAnalystSearch = (query) => {
        this.props.getAssignedTEMAnalystDropdownAsync(1, query);
    };

    loadMoreTEMAnalyst = (searchString) => {
        const { orderDetails } = this.props;
        const nextPage = (orderDetails.analystPage || 1) + 1;
        this.props.getAssignedTEMAnalystDropdownAsync(nextPage, searchString);
    };

    handleCountrySearch = (query) => {
        this.props.getCountriesDropdownAsync(1, query);
    };

    loadMoreCountry = (searchString) => {
        const { orderDetails } = this.props;
        const nextPage = (orderDetails.countryPage || 1) + 1;
        this.props.getCountriesDropdownAsync(nextPage, searchString);
    };

    handleDeliveryAddressSearch = (query) => {
        const { orderDetailsForm, form = {} } = this.props;

        if (!orderDetailsForm) return; // exit if undefined

        const countryCode = orderDetailsForm.country;
        if (!countryCode) return;

        this.props.getDeliveryAddressDropdownAsync(countryCode, 1, query);
    };

    loadMoreDeliveryAddress = (searchString = '') => {
        const { orderDetailsForm, orderDetails, form = {} } = this.props;
        const { deliveryAddressPage = 1 } = orderDetails;

        if (!orderDetailsForm.country) return;

        const nextPage = deliveryAddressPage + 1;

        this.props.getDeliveryAddressDropdownAsync(orderDetailsForm.country, nextPage, searchString);
    };


    render() {
        const { adminSetting, orderDetails, orderDetailsForm, selectTemAnalyst, requestTypeId, 
            orderMilestoneDetails, isReadAndWrite, stripeInfo, orderDetailsId, orderNumber } = this.props;
        const { orderMilestone, isLoading, isPaymentLoading } = this.state;
         const { paymentMethod } = this.props.stripeDetails;
        let completeFetch = !orderDetails.fetchingOrderDetails && !isLoading && !orderMilestoneDetails.isLoading;
        var isQuotationRequest =  requestTypeId == REQUEST_TYPES_ID.newQuotation  ? true : false
        const { activeDateFormat } = this.props.adminSetting;
        const DealId = sessionStorage.getItem('DealId');
        return (
            <>
                {!completeFetch
                    ? <NoSubscription /> :
                    <>
                        <div className="order-form-container">
                            <div className={`order-details-milestone ${orderDetails.orderData.ApprovalStatusId === 1 && !this.state.rejectedCancel ? 'milestone-status-pending' : ''}`}>
                                {
                                    <Milestone
                                        refNode={this.milestoneRef}
                                        containerClass="form-details-container"
                                        onSelectedMilestone={this.state.showSelection}
                                        enableHover={true}
                                        hoverMessage={this.selectedMilestoneData()}
                                        allowAllClickableIcon={true} icon={"filler"}
                                        handleAction={this.onClickMilestone}
                                        milestonesLabel="order_milestone"
                                        milestones={orderMilestone}
                                        activeIndex={this.state.activeIndex}
                                        dateFormat={adminSetting?.activeDateFormat?.Name}
                                        isReadAndWrite={true}
                                    />
                                }

                            </div>

                            {isQuotationRequest ?
                                <span className="order-details-link" onClick={() => this.handleOpenRequestDetails()}>Quotation Request Details</span> :
                                <span className="order-details-link" onClick={() => this.handleOpenRequestDetails()}>Order Request Details</span>} 
                                {
                                    stripeInfo.hasRecord && DealId != CLIENTID.bobst ?
                                        <span className="order-details-link" onClick={()=> this.handleFetchStripeInfo(orderDetailsId)}>Payment Information</span>
                                        : null
                                }
                               
                            <div className="hr-management-form-container details-container mb-3 invoice-detail-container">
                                <div className="details-field-container">
                                        
                                        {!isQuotationRequest &&
                                            <InputField
                                                className="form-control"
                                                type="text"
                                                label={this.toLocaleLanguage("order_number")}
                                                value={orderDetailsForm.orderNumber}
                                                fieldProp='orderDetailsForm.orderNumber'
                                                maxLength={MAX_LENGTH.limit_100}
                                                placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                                disabled={true}
                                            />
                                        }

                                        { (Object.values(WIRELINE_REQUEST_TYPES_ID).includes(requestTypeId) || isQuotationRequest) &&
                                                <InputField
                                                    className="form-control"
                                                    type="text"
                                                    label={this.toLocaleLanguage("sr_number")}
                                                    value={orderDetailsForm.srNumber}
                                                    fieldProp='orderDetailsForm.srNumber'
                                                    maxLength={MAX_LENGTH.limit_100}
                                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                                    disabled={this.isOrderStatusCompleted() || isQuotationRequest}

                                                />
                                        }

                                        <InputField
                                                className="form-control"
                                                type="text"
                                                label={this.toLocaleLanguage("request_type")}
                                                value={orderDetailsForm.requestType}
                                                fieldProp='orderDetailsForm.requestType'
                                                maxLength={MAX_LENGTH.limit_100}
                                                placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                                disabled={true}
                                        />

                                        <CustomSearchableDropdownWrapper
                                            label={this.toLocaleLanguage("assigned_tem_analyst")}
                                            options={orderDetails.assignedTEMAnalystDropdown}
                                            selected={orderDetailsForm.assignedTEMAnalystId}
                                            onChange={(e) => selectTemAnalyst('orderDetailsForm.assignedTEMAnalystId', e)}
                                            requiredField
                                            isNullable={true}
                                            placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                            fieldProp='orderDetailsForm.assignedTEMAnalystId'
                                            tagName='assignedTEMAnalystId'
                                            disabled={this.isOrderStatusCompleted()}
                                            optionLabelKey={{
                                                Key: 'Key',
                                                Value: 'Value'
                                            }}
                                            maxLength={MAX_LENGTH.limit_100}
                                            onSearchChange={this.handleTEMAnalystSearch}
                                            onLoadMore={this.loadMoreTEMAnalyst}
                                            isLoading={orderDetails.isTEMAnalystLoading}
                                            hasMore={orderDetails.hasMoreTEMAnalyst}
                                         />

                                        <InputField
                                            className="form-control"
                                            type="text"
                                            label={this.toLocaleLanguage("created_date")}
                                            value={convertToFormatLocalDate(orderDetailsForm.createdDate, activeDateFormat.Name)}
                                            fieldProp='orderDetailsForm.createdDate'
                                            maxLength={MAX_LENGTH.limit_100}
                                            placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                            disabled={true}
                                        />

                                        <InputField
                                            className="form-control"
                                            type="text"
                                            label={this.toLocaleLanguage("requestor")}
                                            value={orderDetailsForm.requestor}
                                            fieldProp='orderDetailsForm.requestor'
                                            maxLength={MAX_LENGTH.limit_100}
                                            placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                            disabled={true}
                                        />

                                        {
                                            isQuotationRequest &&
                                                <InputField
                                                    className="form-control"
                                                    type="text"
                                                    label={"Vendor"}
                                                    value={orderDetailsForm.vendorList}
                                                    fieldProp='orderDetailsForm.requestor'
                                                    maxLength={MAX_LENGTH.limit_100}
                                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                                    disabled={true}
                                                />
                                        }
                                       
                                        <Select
                                            className="required form-select no-placeholder"
                                            label={this.toLocaleLanguage("order_status")}
                                            value={orderDetailsForm.orderStatusId}
                                            options={orderDetails.orderStatusDropdown}
                                            placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                            fieldProp='orderDetailsForm.orderStatusId'
                                            disabled={this.isOrderStatusCompleted()}
                                            optionLabelKey={{
                                                Key: "Key",
                                                Value: "Value"
                                            }}
                                        />

                                        <InputField
                                            className="form-control"
                                            type="text"
                                            label={this.toLocaleLanguage("order_completion_date")}
                                            value={convertToFormatLocalDate(orderDetailsForm.orderCompletionDate, activeDateFormat.Name)}
                                            fieldProp='orderDetailsForm.orderCompletionDate'
                                            maxLength={MAX_LENGTH.limit_100}
                                            disabled={true}

                                        />

                                        <InputField
                                            className="form-control"
                                            type="text"
                                            label={this.toLocaleLanguage("owner")}
                                            value={orderDetailsForm.owner}
                                            fieldProp='orderDetailsForm.owner'
                                            maxLength={MAX_LENGTH.limit_100}
                                            placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                            disabled={true}
                                        />
                                        {
                                            !isQuotationRequest &&
                                                <InputField
                                                    className="form-control"
                                                    type="number"
                                                    label={this.toLocaleLanguage("contract_term")}
                                                    value={orderDetailsForm.contractTerm}
                                                    fieldProp='orderDetailsForm.contractTerm'
                                                    maxLength={MAX_LENGTH.limit_100}
                                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                                    disabled={this.isOrderStatusCompleted()}
                                                />
                                        }                                        

                                        { !isQuotationRequest &&
                                            <Select
                                                className="form-select required"
                                                label={this.toLocaleLanguage("approval_status")}
                                                value={orderDetailsForm.approvalStatusId}
                                                options={orderDetails.approvalStatusDropdown}
                                                placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                                fieldProp='orderDetailsForm.approvalStatusId'
                                                disabled={this.isOrderStatusCompleted()}
                                                optionLabelKey={{
                                                    Key: "Key",
                                                    Value: "Value"
                                                }}
                                            />
                                        }

                                        { (Object.values(WIRELESS_REQUEST_TYPES_IDS).includes(requestTypeId)) &&
                                            <InputField
                                                className="form-control"
                                                type="text"
                                                label={this.toLocaleLanguage("cost_center")}
                                                value={orderDetailsForm.companyCode}
                                                fieldProp='orderDetailsForm.companyCode'
                                                maxLength={MAX_LENGTH.limit_100}
                                                placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                                disabled={true}
                                            />
                                        }                                        

                                    {!isQuotationRequest &&
                                        <div className="tabber-form-container">
                                            <TabberButton
                                                ref={this.TabberButtonExpediteRequest}
                                                title={this.toLocaleLanguage("expedite_request")}
                                                onToggle={(isActive) => this.props.FormChange("orderDetailsForm.expediteRequest", isActive)}
                                                value={orderDetailsForm.expediteRequest}
                                                disabled={this.isOrderStatusCompleted()}
                                            />
                                        </div>
                                    }
                                </div>
                                {(!isQuotationRequest) ?
                                    <>
                                        <ApproverDetails disabled={this.isOrderStatusCompleted()} translator={this.toLocaleLanguage} requestTypeId={requestTypeId} />
                                        <OrderLocationDetails
                                            disabled={this.isOrderStatusCompleted()}
                                            translator={this.toLocaleLanguage}
                                            handleCountrySearch={this.handleCountrySearch}
                                            loadMoreCountry={this.loadMoreCountry}
                                            handleDeliveryAddressSearch={this.handleDeliveryAddressSearch}
                                            loadMoreDeliveryAddress={this.loadMoreDeliveryAddress}
                                        />
                                        {
                                            Object.values(WIRELINE_REQUEST_TYPES_ID).includes(requestTypeId) &&
                                            <ContactInformationDetails disabled={this.isOrderStatusCompleted()} translator={this.toLocaleLanguage} />
                                        }
                                    </> : null
                                }
                            </div>
                            <div className='order-details-form save-btn-container'>


                                <NotificationModal
                                    show={this.state.saveNotif.show}
                                    title={this.state.saveNotif.title}
                                    message={this.state.saveNotif.message}
                                    handleModal={this.handleNotification}
                                    customClass={'comment-notification-modal modal-text-bold notification-footer'}
                                />
                                <ConfirmationModal
                                    ref={this.ConfirmationModal}
                                    title={this.state.saveModal.title}
                                    messageBody={this.state.saveModal.messageBody}
                                    confirmAction={this.state.saveModal.confirmAction}
                                    closeLabel={this.toLocaleLanguage("no_button")}
                                    confirmLabel={this.toLocaleLanguage("yes_button")}
                                />
                                {isReadAndWrite &&
                                    <>
                                        <div className="tooltip-container">
                                            {this.canCancelOrder() &&
                                                <div className="btn-tooltiptext">
                                                    <Button className="cancel-details-btn btn-secondary"
                                                        variant="outline-secondary"
                                                        onClick={() => { this.handleButtonConfirmation(false) }}>
                                                        <Translation translationKey="cancel_request_button" />
                                                    </Button>
                                                    <div className="cancel-tooltip-text-container">
                                                        <span className="tooltip-text-cancel">Cancel order </span>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        <div className="tooltip-container">
                                            {
                                                this.canCancelOrder() &&
                                                <div className="btn-tooltiptext">
                                                    <Button className='save-details-btn btn btn-primary'
                                                        disabled={this.disableSaveChanges()}
                                                        onClick={() => { this.handleButtonConfirmation() }}
                                                        type='submit'>
                                                        Save Changes
                                                    </Button>
                                                    <div className="save-tooltip-text-container">
                                                        <span className="tooltip-text-save">{this.toLocaleLanguage("save_changes_on_the_order")}</span>
                                                    </div>
                                                </div>
                                            }

                                        </div>
                                    </>
                                }
                            </div>
                        </div>

                        <ModalContainer
                            title="payment_information"
                            show={this.state.showPaymentInfo}
                            handleModal={this.handleCloseFormModal}
                            hideBtn={true}
                            customClass="modal-blur"
                        >  
                            <PaymentDetails 
                                isLoading={isPaymentLoading}
                                cardholderName={paymentMethod?.billing_details?.name}
                                cardNumberLast4={paymentMethod?.card?.last4}
                                cardType={paymentMethod?.card?.brand}
                                customerEmail={paymentMethod?.billing_details?.email}
                                customerPhone={paymentMethod?.billing_details?.phone}
                                virtualCardEnabled={true}
                                expiryDate={paymentMethod?.card?.exp_month + ' / ' + paymentMethod?.card?.exp_year}
                                billingAddress={paymentMethod?.billing_details?.address?.country + ' ' + 
                                    paymentMethod?.billing_details?.address?.postal_code + ' ' + 
                                    paymentMethod?.billing_details?.address?.line1}    
                                orderId={orderDetailsId}
                                orderNumber={orderNumber} 
                                amount={stripeInfo.Amount}                           
                            />
                        </ModalContainer>
                    </>
                }

                <NotificationModal
                    show={this.state.showNotif}
                    title={this.state.notifTitle}
                    message={this.state.notifMessage}
                    handleModal={this.closeNotif}
                    customClass={'comment-notification-modal modal-text-bold notification-footer'}
                />
                {
                    this.renderMilestoneComponent() && (
                        <ModalContainer
                            title={this.state.formModalTitle}
                            show={this.state.showModalForm}
                            handleModal={this.closeFormModal}
                            hideBtn={this.state.hideModalFormBtn}
                            saveDetails={this.onClickSaveModal}
                            customClass={`${requestTypeId !== REQUEST_TYPES_ID.newQuotation ? 'milestone-form__modal custom-form__modal date-picker-main-container' : 'milestone-q-form__modal custom-form_modal'}`}
                            disabled={this.disabledModalBtn()}
                            isReadAndWrite={isReadAndWrite}
                        >
                            {this.renderMilestoneComponent()}
                        </ModalContainer>
                    )
                }
            </>
        );
    }
}
export default connect(
    state => {
        const { inventoryCircuitSIM, stripeDetails, inventoryCircuitEquip, orderDetails, orderMilestoneDetails, translation,
            form: { forms: { orderDetailsForm: { $form } } }, adminSetting
        } = state;
        const { orderDetailsForm, orderMilestoneForm, circuitOrderForm } = state.form;
        return {
            orderMilestoneForm,
            ...translation,
            inventoryCircuitEquip,
            orderDetails,
            orderDetailsForm,
            orderMilestoneDetails,
            adminSetting,
            $form,
            circuitOrderForm,
            inventoryCircuitSIM,
            stripeDetails
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, orderDetailsActions, orderMilestoneAction, circuitOrderActions, 
                inventoryCircuitEquipActions, inventoryCircuitSimActions, stripeActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(OrderDetailsForm);